import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-718bf952"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form__information" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "form__title" }, "REDEFINIÇÃO DE SENHA", -1))
const _hoisted_3 = { class: "form__description" }
const _hoisted_4 = { class: "inputs" }
const _hoisted_5 = {
  key: 1,
  class: "divisor"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ou", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line" }, null, -1))
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "pair" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "form__button",
  type: "submit"
}, "redefinir senha", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modern_input = _resolveComponent("modern-input")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.$emit('post', $setup.userData)), ["prevent"])),
    id: "identify-form",
    class: "form"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString($setup.setDescriptionModal()), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!$setup.isGTopTemplate())
        ? (_openBlock(), _createBlock(_component_modern_input, {
            key: 0,
            form: "identify-form",
            class: "modern-input",
            id: "email",
            label: "E-mail",
            type: "email",
            userData: $setup.userData.email,
            "onUpdate:userData": _cache[0] || (_cache[0] = ($event: any) => (($setup.userData.email) = $event)),
            required: 
          !$setup.userData.birthDate ||
            !$setup.userData.badgeCode ||
            !$setup.userData.document ||
            !$setup.userData.mothersName ||
            !$setup.userData.mothersName
        
          }, null, 8, ["userData", "required"]))
        : _createCommentVNode("", true),
      (!$setup.isGTopTemplate())
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_9))
        : _createCommentVNode("", true),
      _createVNode(_component_modern_input, {
        form: "identify-form",
        class: "modern-input",
        id: "name",
        label: "Nome",
        type: "text",
        userData: $setup.userData.name,
        "onUpdate:userData": _cache[1] || (_cache[1] = ($event: any) => (($setup.userData.name) = $event)),
        required: 
          !$setup.userData.email &&
            (!$setup.userData.birthDate ||
              !$setup.userData.badgeCode ||
              !$setup.userData.document ||
              !$setup.userData.mothersName)
        
      }, null, 8, ["userData", "required"]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_modern_input, {
          form: "identify-form",
          required: 
            !$setup.userData.email &&
              (!$setup.userData.name ||
                !$setup.userData.badgeCode ||
                !$setup.userData.document ||
                !$setup.userData.mothersName)
          ,
          class: "modern-input",
          id: "birthDate",
          label: "Data de nascimento",
          type: "date",
          userData: $setup.userData.birthDate,
          "onUpdate:userData": _cache[2] || (_cache[2] = ($event: any) => (($setup.userData.birthDate) = $event))
        }, null, 8, ["required", "userData"]),
        _createVNode(_component_modern_input, {
          form: "identify-form",
          required: 
            !$setup.userData.email &&
              (!$setup.userData.birthDate ||
                !$setup.userData.name ||
                !$setup.userData.document ||
                !$setup.userData.mothersName)
          ,
          class: "modern-input",
          id: "badgeCode",
          label: "Código do cracha",
          type: "number",
          userData: $setup.userData.badgeCode,
          "onUpdate:userData": _cache[3] || (_cache[3] = ($event: any) => (($setup.userData.badgeCode) = $event))
        }, null, 8, ["required", "userData"])
      ]),
      _createVNode(_component_modern_input, {
        form: "identify-form",
        required: 
          !$setup.userData.email &&
            (!$setup.userData.birthDate ||
              !$setup.userData.badgeCode ||
              !$setup.userData.name ||
              !$setup.userData.mothersName)
        ,
        class: "modern-input",
        id: "document",
        label: "CPF",
        type: "text",
        userData: $setup.userData.document,
        "onUpdate:userData": _cache[4] || (_cache[4] = ($event: any) => (($setup.userData.document) = $event)),
        "has-mask": "",
        "input-mask": "###.###.###-##",
        "max-length": "14"
      }, null, 8, ["required", "userData"]),
      _createVNode(_component_modern_input, {
        form: "identify-form",
        required: 
          !$setup.userData.email &&
            (!$setup.userData.birthDate ||
              !$setup.userData.badgeCode ||
              !$setup.userData.document ||
              !$setup.userData.name)
        ,
        class: "modern-input",
        id: "mothersName",
        label: "Nome da mãe",
        type: "text",
        userData: $setup.userData.mothersName,
        "onUpdate:userData": _cache[5] || (_cache[5] = ($event: any) => (($setup.userData.mothersName) = $event))
      }, null, 8, ["required", "userData"])
    ]),
    _hoisted_11
  ], 32))
}